export default __webpack_public_path__ + "static/media/left-border.7641c0a5.svg";